const config = {
    components: {
        mainMenu: {
            show: false,
        },
        moduleMenu: {
            show: false,
        },
        entityStack: {
            filter: {
                visible: false,
            },
        },
        minireport: {
            enable: false,
        },
    },
    modules: {
        report: {
            enable: true,
        },
        portfolio: {
            enable: true,
        },
    },
    iframeSolution: true,
    history: {
        basename: '/v3/',
    },
}

module.exports = config
